// import axios from 'axios';
import { API } from 'aws-amplify';

export default class ApiManager{
	constructor(name, path, headers){
		this.name = name;
		this.defaultPath = path;

		this.executing = {};
	}
	post(){
		let path,
			body = {};


		if( arguments.length > 0 ){
			path = typeof arguments[0] == 'string'? arguments[0]:this.defaultPath;
		}

		if( arguments.length > 1 ){
			if(typeof arguments[1] == 'object' && !!arguments[1])
				body = arguments[1];
			else if( typeof arguments[1] == 'string' )
				body[arguments[1]] = arguments[1];
		}

		let params = {
			body
		};

		if( !!this.executing[path] )
			API.cancel(this.executing[path], {estado: -1, mensage:'Se ha cancelado, la llamada'});
		
		// se retorna la promesa
		// se puede manejar con callback then() o con await
		try{

			this.executing[path] = API.post(this.name, path, params);
			return this.executing[path];
		}catch(err){

			if(!API.isCancel(err)) {
				throw err;
			}
		}
	}
	getCall(){
		let path,
			queryStringParameters = {};


		if( arguments.length > 0 ){
			path = typeof arguments[0] == 'string'? arguments[0]:this.defaultPath;
		}

		if( arguments.length == 2 ){
			if(typeof arguments[1] == 'object' && !!arguments[1]){
				let _params = arguments[1];
				for( let key in _params ){
					queryStringParameters[key] = typeof _params[key] == 'object' || Array.isArray(_params[key])?
						JSON.stringify(_params[key]):
						_params[key];
				}
			}	else if( typeof arguments[1] == 'string' )
				queryStringParameters[arguments[1]] = arguments[1];
		}

		let params = {
			queryStringParameters
		};

		// se cancela en caso de que se haya hecho una llamada con esa ruta
		if( !!this.executing[path] )
			API.cancel(this.executing[path], {estado: -1, mensage:'Se ha cancelado, la llamada'});

		// se retorna la promesa
		// se puede manejar con callback then() o con await
		try{
			this.executing[path] = API.get(this.name, path, params);
			return this.executing[path];
		}catch(err){
			if( typeof err == 'object' && !!err ){
				if(!err.hasOwnProperty('estado')){
					throw err;
				}else{
					// en caso de que se cancele
					
				}
			}
		}
	}
}